/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click any driver or constructor to open their full profile page with charts, head-to-head comparisons, and season-by-season breakdowns.`)
};

const es_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic en cualquier piloto o constructor para abrir su página de perfil completa con gráficos, comparaciones directas y desgloses temporada por temporada.`)
};

const de_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicke auf einen Fahrer oder Konstrukteur, um die vollständige Profilseite mit Diagrammen, Direktvergleichen und Saison-für-Saison-Aufschlüsselungen zu öffnen.`)
};

const nl_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik op een coureur of constructeur om de volledige profielpagina te openen met grafieken, directe vergelijkingen en seizoen-voor-seizoen analyses.`)
};

const fr_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur n’importe quel pilote ou constructeur pour ouvrir sa page de profil complète avec graphiques, comparaisons directes et analyses saison par saison.`)
};

const it_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca su qualsiasi pilota o costruttore per aprire la pagina profilo completa con grafici, confronti diretti e analisi stagione per stagione.`)
};

const pt_br2_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique em qualquer piloto ou construtor para abrir a página de perfil completa com gráficos, comparações diretas e análises temporada por temporada.`)
};

const pt_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique em qualquer piloto ou construtor para abrir a página de perfil completa com gráficos, comparações diretas e análises época a época.`)
};

const ja_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意のドライバーまたはコンストラクターをクリックして、チャート、直接比較、シーズンごとの分析を含む完全なプロフィールページを開きましょう。`)
};

const zh_f1_stats_how_p3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击任意车手或车队，打开完整的个人资料页面，包含图表、直接比较和逐赛季分析。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_how_p3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_how_p3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_how_p3", locale)
	if (locale === "en") return en_f1_stats_how_p3(inputs)
	if (locale === "es") return es_f1_stats_how_p3(inputs)
	if (locale === "de") return de_f1_stats_how_p3(inputs)
	if (locale === "nl") return nl_f1_stats_how_p3(inputs)
	if (locale === "fr") return fr_f1_stats_how_p3(inputs)
	if (locale === "it") return it_f1_stats_how_p3(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_how_p3(inputs)
	if (locale === "pt") return pt_f1_stats_how_p3(inputs)
	if (locale === "ja") return ja_f1_stats_how_p3(inputs)
	return zh_f1_stats_how_p3(inputs)
};